import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
// import aiAgentsPlugin from '@internal/plugin-ai-agents';
import { navModule } from './modules/nav';
import {
  configApiRef,
  githubAuthApiRef,
  googleAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import {
  SignInPage,
  type SignInProviderConfig,
} from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const githubProvider: SignInProviderConfig = {
  id: 'github-auth-provider',
  title: 'GitHub',
  message: 'Sign in using GitHub',
  apiRef: githubAuthApiRef,
};

const googleProvider: SignInProviderConfig = {
  id: 'google-auth-provider',
  title: 'Google',
  message: 'Sign in using Google',
  apiRef: googleAuthApiRef,
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);

      if (configApi.getString('auth.environment') === 'development') {
        return (
          <SignInPage
            {...props}
            providers={[
              // 'guest',
              githubProvider,
              googleProvider,
            ]}
          />
        );
      }

      return (
        <SignInPage {...props} providers={[githubProvider, googleProvider]} />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    // aiAgentsPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
